<template>
    <div align="center" style="height: auto">
        <div class="commonSearch bottom" :style="defaultHeight">
            <div class="box">
                <el-card class="box-card" v-if="returnData.length==0">
                    <div>暂无数据</div>
                </el-card>

                <el-card class="box-card" v-for="(item, i) in returnData" :key="i" style="cursor: pointer">
                    <div @click="goDetail(item)">
                        <div>
                            <span style="font-size: 22px;margin-right: 10px">{{item.faulttypeName}}</span>
                            <el-button class="state" v-if="item.status==100401" style="border-color: #F56C6C;color: #F56C6C;">新受理</el-button>
                            <el-button class="state" v-if="item.status==100402" style="border-color: #E6A23C;color: #E6A23C;">处理中</el-button>
                            <el-button class="state" v-if="item.status==100404 || item.status==100405" style="border-color: #67C23A;color: #67C23A;">已完成</el-button>
                        </div>
                        <div style="font-size: 16px;">报修时间:&nbsp;&nbsp;{{item.createdate}}</div>
                        <div style="font-size: 16px;">报修单号:&nbsp;&nbsp;{{item.repaircode}}</div>
                    </div>
                    <div class="el-icon-arrow-right" ref=""></div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import RepairsApi from "@/api/repairs.js";

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            returnData: [],
            createdate: "",
            faulttype: "",
            repaircode: "",
            status: '',
            userid: "",
            defaultHeight: {
                height: ""
            }
        };
    },

    mounted: function () {
        this.findBxlb();
    },

    methods: {
        getHeight () {
            this.defaultHeight.height = window.innerHeight - 90 + "px";
        },
        findBxlb () {
            let currentUser = this.$constant.GET_USER();
            RepairsApi.getClass()
                .findPages({
                    userid: currentUser.id
                }).then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        let common_table_info = [];
                        for (let i in res2.data.data) {
                            common_table_info.push(res2.data.data[i]);
                        }
                        this.returnData = common_table_info;
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },
        goDetail (val) {
            let row = val;
            this.$router.push({
                name: "ViewDetails",
                query: { id: row.orderid }
            });
        }
    },
    created () {
        window.addEventListener("resize", this.getHeight);
        this.getHeight();
    }
};
</script>

<style lang="stylus" scoped>
.top {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: left;
    font-size: 18px;
    width: 90%;
    color: #F8F8FF;
    height: 30px;
    background-color: #3D84FF;
}

.bottom {
    width: 90%;
    height: 820px;
    overflow: auto;
}

/deep/.el-button--small {
    margin-left: 15px;
}

.state {
    font-size: 12px;
    height: 30px;
    width: 65px;
}

.box-card {
    width: 500px;
    position: relative;
    height: 110px;
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: left;

    .el-icon-arrow-right {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>